import { Registration } from '../API';
import { parseAdditionalData } from './parseAdditionalData';
import { CSV_EXPORT_HEADERS } from '../constants/config';

export function generateAttendeeCsv(attendees: Registration[]): string {
  let csvContent = 'data:text/csv;charset=utf-8,';
  csvContent += CSV_EXPORT_HEADERS.join(',') + '\n';
  attendees.forEach(att => {
    const parsed = parseAdditionalData(att.additionalData);
    const row = [
      att.registrationId,
      att.email,
      att.firstName,
      att.lastName,
      att.registrationStatus,
      att.dateCreated,
      parsed.notes || '',
      parsed.membership || '',
      parsed.title || '',
    ];
    csvContent += row.join(',') + '\n';
  });
  return csvContent;
}

export function downloadCsv(csvContent: string, filename: string): void {
  const encodedUri = encodeURI(csvContent);
  const link = document.createElement('a');
  link.setAttribute('href', encodedUri);
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
